import { components } from 'react-select';
import { observer } from 'mobx-react';
import React from 'react';

const BaasicDropdownOptionOverride = ({ shouldDisplayCallback, Component, LeadingComponent, ...otherProps }) => {
	const { Option } = components;
	const { data } = otherProps;
	const displayOverrideOption = shouldDisplayCallback ? shouldDisplayCallback(data) : true;
	return (
		<Option {...otherProps}>
			{LeadingComponent && <LeadingComponent {...otherProps} />}
			{data.label}
			{displayOverrideOption && <Component {...otherProps} />}
		</Option>
	);
};

export default observer(BaasicDropdownOptionOverride);
